<template>
  <section>
    <loader fill v-if="loading" />
    <div class="home" v-else>
      <masthead />
      <div class="home__previews">
        <latest-preview />
        <first-preview />
        <archive-preview />
        <subscribe-preview />
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import Loader from '@/components/Loader.vue';
import Masthead from './home/Masthead.vue';
import LatestPreview from './home/LatestPreview.vue';
import FirstPreview from './home/FirstPreview.vue';
import SubscribePreview from './home/SubscribePreview.vue';
import ArchivePreview from './home/ArchivePreview.vue';

export default {
  name: 'Home',
  components: {
    Loader,
    Masthead,
    LatestPreview,
    FirstPreview,
    SubscribePreview,
    ArchivePreview,
  },
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.loading = true;
    const requests = [
      this.fetchStrip({ stripNumber: 1 }),
      this.fetchLatestStrip(),
    ];
    Promise.all(requests).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    ...mapActions([
      'fetch',
      'fetchStrip',
      'fetchLatestStrip',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  &__previews {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr;
    max-width: 1000px;
    gap: 30px;
    padding: 50px 30px;
    margin: 0 auto;
    @media all and (max-width: 800px) {
      grid-template-columns: auto;
      padding: 30px;
    }
  }
}
</style>
